/**
 * WalterGO PED-Quiz Umami-Tracker (v1.4 Event-Schema)
 * Spec: analytics/tracking-spec.md §3.4 + §4.4
 *
 * DOCKT AN: existierende DOM-Elemente (NO-TOUCH-Prinzip)
 *   #OpenQuestionnaire             — Quiz öffnen
 *   [data-widget="continue-button"][data-target] — Step-Wechsel
 *   #OverlayProductSubmit          — Submit
 *
 * SENDET PRO QUIZ (max. 9 Events):
 *   ped.quiz.start
 *   ped.quiz.step.1_intro                    Property: time_on_previous_step_ms (außer step 1)
 *   ped.quiz.step.2_foot_type
 *   ped.quiz.step.3_pain
 *   ped.quiz.step.4_gender
 *   ped.quiz.step.5_shoe_type
 *   ped.quiz.step.6_shoe_size
 *   ped.quiz.step.7_personal_info
 *   ped.quiz.complete                        Property: total_duration_ms
 *   ped.quiz.abandon.N_name                  Property: total_duration_ms   (statt complete, wenn unfertig)
 *
 * DSGVO-arm: keine User-Eingaben / Auswahl-Werte tracken.
 */
(function () {
  'use strict';

  // DOM-Section-ID → kanonischer Step-Slug (Index + Name)
  var STEP_MAP = {
    'intro-section':         { index: 1, slug: '1_intro' },
    'foot-type-section':     { index: 2, slug: '2_foot_type' },
    'pain-section':          { index: 3, slug: '3_pain' },
    'gender-section':        { index: 4, slug: '4_gender' },
    'shoe-type-section':     { index: 5, slug: '5_shoe_type' },
    'shoe-size-section':     { index: 6, slug: '6_shoe_size' },
    'personal-info-section': { index: 7, slug: '7_personal_info' }
  };

  var quizStartAt = null;
  var stepStartAt = null;
  var currentStep = null; // { index, slug } | null
  var completed = false;

  function track(name, data) {
    if (typeof window.wgTrack === 'function') {
      window.wgTrack(name, data);
    }
  }

  function fireStepReached(step) {
    // Defensive Guard 1: Step-Events nur, wenn Quiz via Open-Btn gestartet wurde.
    // Verhindert step-vor-start-Reihenfolge bei Deep-Link / DevTools-Bypass.
    if (quizStartAt === null) return;
    // Defensive Guard 2: keine Step-Events mehr nach complete — User kann durch
    // Sections scrollen oder zurück-navigieren ohne dass das die Funnel-Daten
    // verzerrt (post-complete-step-events sind semantisch sinnlos).
    if (completed) return;
    if (currentStep && currentStep.index === step.index) return;
    var now = Date.now();
    var data = null;
    if (stepStartAt !== null && currentStep !== null) {
      data = { time_on_previous_step_ms: now - stepStartAt };
    }
    track('ped.quiz.step.' + step.slug, data);
    currentStep = step;
    stepStartAt = now;
  }

  function fireAbandonIfNeeded() {
    if (quizStartAt === null || completed) return;
    var step = currentStep || STEP_MAP['intro-section'];
    track('ped.quiz.abandon.' + step.slug, {
      total_duration_ms: Date.now() - quizStartAt
    });
    quizStartAt = null; // verhindert doppeltes Feuern bei pagehide+beforeunload
  }

  function init() {
    var openBtn = document.getElementById('OpenQuestionnaire');
    if (!openBtn) return;

    openBtn.addEventListener('click', function () {
      // Mehrfach-Open (z.B. nach Abbruch): vorherige Session als abandon abschließen
      if (quizStartAt !== null && !completed) {
        fireAbandonIfNeeded();
      }
      quizStartAt = Date.now();
      stepStartAt = Date.now();
      currentStep = null;
      completed = false;
      track('ped.quiz.start');
      fireStepReached(STEP_MAP['intro-section']);
    });

    document.querySelectorAll('[data-widget="continue-button"][data-target]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        if (quizStartAt === null) return; // Defensive Guard: kein Start → kein Step-Event
        var target = btn.dataset.target;
        var step = STEP_MAP[target];
        if (step) fireStepReached(step);
      });
    });

    var submitBtn = document.getElementById('OverlayProductSubmit');
    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        if (quizStartAt === null) return;
        // Defensive Guard: Doppel-Klick auf Submit darf complete nicht mehrfach
        // feuern (User klickt "passiert was?" → nochmal → vor v1.6 = 2x complete).
        if (completed) return;
        completed = true;
        track('ped.quiz.complete', {
          total_duration_ms: Date.now() - quizStartAt
        });
      });
    }

    window.addEventListener('pagehide', fireAbandonIfNeeded);
    window.addEventListener('beforeunload', fireAbandonIfNeeded);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
